import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ControlBase } from '@components/dynamic-form/control-base';
import { FormGroup } from '@angular/forms';
import { InputFieldComponent } from '@components/dynamic-form/input-field.component';

@Component({
  selector: 'app-email',
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.scss'],
})
export class EmailComponent extends InputFieldComponent implements OnChanges {
  @Input() meta!: ControlBase;
  @Input() form!: FormGroup;

  ngOnChanges(changes: SimpleChanges) {
    this.setControl();
  }
}
